import { useEffect } from "react";

import notfoundLottie from "assets/files/notfound-lottie.json";
import { SEO } from "components";
import Lottie from "lottie-react";

const IndexPage = () => {
  useEffect(() => {
    const bodyElm = document.querySelector("body");
    if (!bodyElm) return;

    const currentBgColor = bodyElm.style.backgroundColor;
    bodyElm.style.backgroundColor = "#fff";

    // eslint-disable-next-line consistent-return
    return () => {
      bodyElm.style.backgroundColor = currentBgColor;
    };
  }, []);

  return (
    <>
      <SEO title="Not Found" />
      <Lottie
        animationData={notfoundLottie}
        style={{ width: "100vw", height: "100vh", overflow: "hidden" }}
      />
    </>
  );
};

export default IndexPage;
